var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.87 24.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.94,0l.3,0,.3.08.27.09.25.16.23.19.19.22.16.23.11.28.08.28,0,.3.59.15.55.19.54.24.52.26.5.3.48.34.45.36.42.4.39.42.37.44.33.47.3.5.27.52L18.8,7l.18.55.16.57.11.59.06.6,0,.61v5.56l.34,0,.33.07.31.11.3.14.27.19.25.2.2.24.19.26.15.29.11.31.06.32,0,.34v1.76H0V18l0-.34L.1,17.3.21,17l.13-.29.2-.26.21-.24L1,16l.27-.19.29-.14.31-.11.33-.07.34,0V9.91l0-.61.06-.6.11-.59.15-.57L3.08,7l.23-.54.26-.52.3-.5L4.2,5l.37-.44L5,4.1l.43-.4.44-.36L6.31,3l.5-.3.52-.26.54-.23L8.43,2,9,1.86l0-.3.08-.28L9.24,1,9.4.77,9.59.55,9.81.36l.26-.15.27-.1L10.63,0l.31,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29,21.18h7.29l-.13.41-.18.39-.2.36-.24.35-.28.3-.31.28-.34.24-.35.2-.38.17-.38.1-.42.09-.43,0-.43,0L10.1,24l-.4-.1-.38-.17L9,23.51l-.32-.24L8.32,23l-.27-.3-.24-.35L7.59,22l-.17-.39-.13-.41Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.47c6b15de9ee2b45de4693c86f7bea36.svg";
export { ForwardRef as ReactComponent };